import ReactECharts from "echarts-for-react";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import { useSelector } from "react-redux";
import { FaCheckCircle, FaClock, FaEquals } from "react-icons/fa";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";

const fetchBtlDataApi = async (body) => {
  try {
    const res = await axInst.post("dealer-sales-success-centre/btl_data", body);
    return res.data || {};
  } catch (error) {
    console.error("Service API Error:", error);
    return {};
  }
};

const BTLChart = () => {
  const { data, submitted } = useSelector((e) => e.filtersSalesSuccessCenter);

  const {
    data: btlData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["btlData", submitted],
    queryFn: () => fetchBtlDataApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const btlIcon = [
    {
      name: "Total BTL",
      value: btlData?.Total_BTL ?? 0,
      color: "#6B7280",
      icon: FaEquals,
    },
    {
      name: "Executed",
      value: btlData?.Executed ?? 0,
      color: "#7DB6FB",
      icon: FaCheckCircle,
    },
    {
      name: "Delayed",
      value: btlData?.Delayed ?? 0,
      color: "#6AE497",
      icon: FaClock,
    },
    {
      name: "CPL (₹)",
      value: btlData?.CPL ?? 0,
      color: "#FCA762",
      icon: RiMoneyRupeeCircleFill,
    },
    {
      name: "CPR (₹)",
      value: btlData?.CPR ?? 0,
      color: "#33C3DC",
      icon: RiMoneyRupeeCircleFill,
    },
  ];

  const chartData = [...btlIcon].reverse();

  const option = {
    grid: {
      left: 2,
      right: 0,
      top: 5,
      bottom: 10,
    },
    xAxis: {
      type: "value",
      show: false,
    },
    yAxis: {
      type: "category",
      data: chartData.map((item) => item.name),
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: {
        show: true,
      },
    },
    series: [
      {
        type: "bar",
        barMinHeight: 50,
        data: chartData.map((item) => ({
          value: item.value,
          itemStyle: {
            color: item.color,
            borderRadius: 20,
          },
          label: {
            show: true,
            position: "insideRight",
            formatter: "{c}",
            fontWeight: "bold",
          },
        })),
        barWidth: 20,
        z: 10,
      },
    ],
  };

  return (
    <div className="bg-white rounded-xl shadow p-2 relative h-full">
      <h2 className="pb-2 text-base font-semibold text-[#4c4c4c]">BTL</h2>
      <WaterMark />
      {isFetching ? (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      ) : isError || !btlData || Object.keys(btlData).length === 0 ? (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      ) : (
        <div className="relative">
          <div className="absolute top-0 left-0 z-10 ">
            {btlIcon.map((item, idx) => (
              <div key={idx} className="flex items-center h-[45px]">
                <div
                  className="w-6 h-6 rounded-md flex items-center justify-center mr-2"
                  style={{ backgroundColor: item.color }}
                >
                  <item.icon className="text-white w-4 h-4 " />
                </div>
                <span className="text-sm font-semibold text-gray-700">
                  {item.name}
                </span>
              </div>
            ))}
          </div>

          {/* Right side: chart */}
          <div className="pl-[101px]">
            <ReactECharts
              option={option}
              style={{ height: `${btlIcon.length * 48}px`, width: "150px " }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BTLChart;
